import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import api from "../api/client";
import Logo from "../components/Logo";
import ThemeToggle from "../components/ThemeToggle";
import useAuthStore from "../store/authStore";

export default function VerifyPending() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "";
  const [resent, setResent] = useState(false);
  const seekerToken = useAuthStore((s) => s.seekerToken);

  const handleResend = async () => {
    try {
      await api.post(
        `/auth/resend-verification?email=${encodeURIComponent(email)}`,
      );
      setResent(true);
    } catch {}
  };

  return (
    <div className="min-h-screen bg-brand-light-bg dark:bg-brand-dark-bg flex flex-col">
      <nav className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-white/10">
        <Logo className="h-12" />
        <ThemeToggle />
      </nav>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white dark:bg-brand-dark-surface rounded-2xl border border-gray-100 dark:border-white/10 p-8 w-full max-w-sm text-center">
          <div className="w-14 h-14 bg-brand-violet-tint dark:bg-brand-violet/20 rounded-full flex items-center justify-center mx-auto mb-5">
            <svg
              className="w-7 h-7 text-brand-violet dark:text-brand-violet-on-dark"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
            Check your inbox
          </h1>
          <p className="text-gray-400 text-sm mb-2">
            We sent a verification link to:
          </p>
          <p className="text-brand-violet dark:text-brand-violet-on-dark font-medium text-sm mb-6">{email}</p>
          <p className="text-gray-400 text-xs mb-6">
            Click the link in the email to activate your account. Check your
            spam folder if you don't see it.
          </p>

          {resent ? (
            <p className="text-green-500 text-sm mb-4">
              Verification email resent!
            </p>
          ) : (
            <button
              onClick={handleResend}
              className="text-brand-violet dark:text-brand-violet-on-dark text-sm hover:underline mb-6 block w-full"
            >
              Resend verification email
            </button>
          )}

          <Link
            to="/login"
            className="text-gray-400 text-xs hover:text-gray-600 dark:hover:text-gray-300"
          >
            Already verified? Sign in →
          </Link>
        </div>
      </div>
    </div>
  );
}
